import { getActiveTab } from './helperFunctions'
import { reProject, reprojectD3 } from './functions'
import { g, updateSVG } from './map/d3Renderer'
import { enableEditButtons } from './map/drawing'
import { getEpsg, getEpsgCode, map } from './map/tools'
import { vectorLayer } from './map/layers'
import { loadingGeometry, materializeToast, simpleToast } from './notifications'
import {
  collection, CURRENT_GEOTYPE, currentLayerId, currentDataProj,
  debug, i18n,
  setCurrentDataExtent, setCurrentDataProj, setD3Collection, setHighlighted
} from './storage'
import { invisibleStyle } from './styles'

import GeoJSON from 'ol/format/GeoJSON'
import TopoJSON from 'ol/format/TopoJSON'
import { fromExtent } from 'ol/geom/Polygon'
import { get as projGet } from 'ol/proj'

import * as topojson from 'topojson-client'

const geotypes = { point: 'Point', line: 'LineString', surface: 'Polygon' };
export const filterGeometries = (json, type) => {
  const gg = json?.objects?.collection?.geometries;
  const olType = geotypes[type];
  const types = [olType, `Multi${olType}`];
  if (gg) json.objects.collection.geometries = gg.filter(
    g => types.indexOf(g.type) > -1
  );
};

export let rest;
export const setRest = (r) => rest = r;

export let editableRegion = true; // updates in notifyAccordingToResponseStatus

const getBboxAsGeojson = () => {
  const extent = map.getView().calculateExtent(map.getSize());
  // workaround, to avoid data disappearing near top boundary:
  extent[3] += (extent[3] - extent[1]) * 0.2;
  const geojson = new GeoJSON();
  const bbox = geojson.writeGeometryObject(new fromExtent(extent));
  // Add projection:
  bbox['crs'] = { type: 'name', properties: { name: getEpsg() } };
  return bbox;
};

export const prepareRequest = (structure) => {
  const pRequest = JSON.parse(structure);
  pRequest['layer_id'] = currentLayerId;
  pRequest['response_srid'] = getEpsgCode();
  pRequest['envelope'] = getBboxAsGeojson();

  // needed in almostSameExtent check
  setCurrentDataExtent(map.getView().calculateExtent(map.getSize()));

  return pRequest;
};

export const notifyOutsideResolution = () => {
  loadingGeometry(false);
  // Remove old SVG object
  g.selectAll('path').remove();
  g.selectAll('text').remove();

  // Avoid almostSameExtent when coming back inside valid resolution:
  setCurrentDataExtent([]);
  // Hide selected feature properties:
  $("#info-box-popup").hide();
  setHighlighted(0);

  $('#zoom-in-info-box-popup').show();
  $('#zoom-in-info-text').text(i18n['generic']['zoom-in-info-text']);
  $('#info-box-choose-edit-type').show(); // give possibility to add gps
};

export const notifyAccordingToResponseStatus = (status) => {
  if (debug < 13) console.log('notifyAccordingToResponseStatus,', status);
  if (status === 0) { // generic error
    const objektet = i18n[CURRENT_GEOTYPE].objektet;
    const msg = 'Det blei en feil i området. Prøv på nytt og/eller sjekk \
      om du har rettigheter for å endre dette ' + objektet + '!';
    materializeToast(msg, 'error');
  } else if (status === 1) { // success
    editableRegion = true;
    $('#zoom-in-info-box-popup').hide();
    if (getActiveTab() === 2) $('#info-box-choose-edit-type').show();
  } else if (status === 2) { // zoom in to edit
    $('#zoom-in-info-box-popup').show();
    $('#zoom-in-info-text').text(i18n['generic']['zoom-in-info-text']);
    $('#info-box-choose-edit-type').hide();
  } else if (status === 3) { // invalid input line (not used for this request)
  } else if (status === 4) { // outside user's editable region
    editableRegion = false;
  } else console.log('Ukjent feil', status);
  enableEditButtons(); // de/activate buttons
};

export const handleResponseGeometry = (json) => {
  if (!json) {
    setD3Collection({});
    // Remove old SVG object
    g.selectAll('path').remove();
    g.selectAll('text').remove();
    $('#zoom-in-info-text').text('Ingen data innenfor valgt område.');
    $('#zoom-in-info-box-popup').show();
  } else {
    try { // D3 geometry is loaded here
      // Convert TopoJSON to GeoJSON, https://github.com/topojson/topojson
      setD3Collection(topojson.feature(json, json.objects.collection));
      setCurrentDataProj(json.crs.properties.name);
    } catch (e) {
      console.log(e);
      console.log('Invalid JSON:', json);
      simpleToast('Kunne ikke hente geometri i dette området', 'error');
      return false;
    }
  }
};

export const loadGeometryToOpenlayers = (json, layer) => {
  layer.getSource().clear();
  if (!json) return;
  let features = [];
  try {
    // OL geometry is loaded here
    const jFormat = json.arcs ? TopoJSON : GeoJSON;
    features = new jFormat({
      dataProjection: projGet('EPSG:4326')
    }).readFeatures(json);
  } catch(e) { }

  // Draw outline on polygons
  layer.getSource().addFeatures(features);

  if (['line', 'point'].indexOf(CURRENT_GEOTYPE) > -1)
    layer.setStyle(invisibleStyle);
};

export const loadGeometryToD3 = () => {
  updateSVG(); // Update D3
  const epsg = getEpsg();
  if (epsg !== currentDataProj) reprojectD3(currentDataProj, epsg);
};
